import React, { useState, useRef, useEffect } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { FaRupeeSign } from "react-icons/fa";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";

const LLPStatementOfAccount = ({ isSubScribe, apiData }) => {
  const [currency, setCurrency] = useState("Crore");
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [financialYears, setFinancialYears] = useState([]);
  const [isStandaltwoOpen, setIsStandaltwoOpen] = useState(true);
  const [isStandalthreeOpen, setIsStandalthreeOpen] = useState(true);
  const [isStandalfourOpen, setIsStandalfourOpen] = useState(true);
  const [isStandalfiveOpen, setIsStandalfiveOpen] = useState(true);
  const [referenceDocsForSelectedYear, setReferenceDocsForSelectedYear] =
    useState(null);

  const tableRef2 = useRef();
  const tableRef3 = useRef();
  const tableRef4 = useRef();
  const tableRef5 = useRef();

  const toggleStandaltwo = () => {
    setIsStandaltwoOpen((prev) => !prev);
  };

  const toggleStandalthree = () => {
    setIsStandalthreeOpen((prev) => !prev);
  };

  const toggleStandalfour = () => {
    setIsStandalfourOpen((prev) => !prev);
  };

  const toggleStandalfive = () => {
    setIsStandalfiveOpen((prev) => !prev);
  };

  const hasData = Array.isArray(apiData) && apiData.length > 0;

  useEffect(() => {
    // Extract unique financial years and sort them
    const years = [
      ...new Set(apiData?.map((item) => item.financial_year)),
    ].sort((a, b) => parseInt(b) - parseInt(a));

    setFinancialYears(years);

    // Default to the first financial year in the sorted list
    if (years.length) {
      setSelectedDateRange(`${years[0]} - ${parseInt(years[0]) + 1}`);
    }
  }, [apiData]);

  useEffect(() => {
    if (selectedDateRange) {
      const selectedYears = selectedDateRange.split(" - ");
      const docs =
        apiData
          .flatMap((item) =>
            item?.FinancialData?.filter((data) =>
              selectedYears.includes(data.financialYear)
            )
          )
          .map((data) => data?.reference_document) || [];

      setReferenceDocsForSelectedYear(docs.find((doc) => doc) || null);
    }
  }, [selectedDateRange, apiData]);

  const filteredData = selectedDateRange
    ? apiData
        .filter((data) =>
          selectedDateRange
            .split("-")
            .map((item) => Number(item))
            .includes(data.financial_year)
        )
        .sort((a, b) => {
          const yearA = parseInt(a.financial_year);
          const yearB = parseInt(b.financial_year);
          return yearA - yearB;
        })
    : [];

  const AssetsandLiabilities = [
    {
      title: "Contribution and Liabilities",
      subcategories: [
        {
          subtitle: "Partner's Funds",
          items: [
            { name: "Contribution Received", key: "contribution_recieved" },
            {
              name: "Reserves and Surplus",
              key: "reserves_and_surplus",
            },
          ],
        },
        {
          subtitle: "Liabilities",
          items: [
            {
              name: "Secured Loans",
              key: "liabilities_secured_loans",
            },
            {
              name: "Unsecured Loans",
              key: "liabilities_unsecured_loans",
            },
            {
              name: "Short Term Borrowing",
              key: "liabilities_shortterm_borrowings",
            },
            {
              name: "Creditor/Trade Payables - Advance from Customers",
              key: "liabilities_creditor_payables",
            },
            {
              name: "Other Liabilities",
              key: "liabilities_other",
            },
          ],
        },
        {
          subtitle: "Provisions",
          items: [
            {
              name: "for Taxation",
              key: "provisions_for_taxation",
            },
            {
              name: "for Contingencies",
              key: "provisions_for_contingencies",
            },
            {
              name: "for Insurance",
              key: "provisions_for_insurance",
            },
            {
              name: "Other Provisions",
              key: "provisions_other",
            },
          ],
        },
      ],
    },
    {
      title: "Assets",
      subcategories: [
        {
          subtitle: "",
          items: [
            { name: "Gross Fixed Assets", key: "assets_gross_fixed" },
            { name: "Less: Depreciation and Amortization", key: "assets_less" },
            { name: "Net Fixed Assets", key: "assets_net_fixed" },
            { name: "Investments", key: "assets_investments" },
            {
              name: "Loans and Advances",
              key: "assets_loans",
            },
            {
              name: "Inventories",
              key: "assets_inventories",
            },
            {
              name: "Debtors/Trade Receivables",
              key: "assets_trade_receivables",
            },
            {
              name: "Cash and Cash Equivalents",
              key: "assets_cash",
            },
            {
              name: "Others Assets",
              key: "assets_others",
            },
          ],
        },
        {
          subtitle: "Total Assets",
          items: [{ name: "Total Assets", key: "assets_total" }],
        },
      ],
    },
  ];

  const IncomeandExpenditure = [
    {
      subcategories: [
        {
          items: [{ name: "Net Revenue", key: "net_revenue" }],
        },
      ],
    },
    {
      title: "Operating Cost",
      subcategories: [
        {
          items: [
            {
              name: "Cost of Materials Consumed",
              key: "cost_of_materialsConsumed",
            },
            {
              name: "Purchases of Stock-in-trade",
              key: "purchases_of_stockTrades",
            },
            {
              name: "Changes in Inventories / Finished Goods",
              key: "changes_in_inventory_finishedGoods",
            },
            {
              name: "Employee Benefit Expense",
              key: "employee_benefit_expense",
            },
            { name: "Other Expenses", key: "otherExpenses" },
            {
              name: "Total Operating Cost",
              key: "total_operating_cost",
              bold: true,
            },
          ],
        },
        {
          items: [
            { name: "Operating Profit ( EBITDA )", key: "operating_profit" },
            { name: "Other Income", key: "other_income" },
            {
              name: "Depreciation and Amortization Expense",
              key: "deprication_amortization_expense",
            },
            { name: "Profit Before Interest and Tax", key: "profit_beforeTax" },
            { name: "Finance Costs", key: "finance_costs" },
            {
              name: "Profit Before Tax and Exceptional Items Before Tax",
              key: "profit_beforeTax_exceptionalItems_beforeTax",
            },
            {
              name: "Exceptional Items Before Tax",
              key: "exceptionalItems_beforeTax",
            },
            { name: "Profit Before Tax", key: "profit_beforeTax" },
            { name: "Income Tax", key: "incomeTax" },
            {
              name: "Profit for the Period from Continuing Operations",
              key: "profit_forthePeriod_continuingOperatioins",
            },
            {
              name: "Profit from Discontinuing Operations After Tax",
              key: "profit_discontinuingOperations_afterTax",
            },
            {
              name: "Profit for the Period",
              key: "profit_forthePeriod",
              bold: true,
            },
          ],
        },
      ],
    },
  ];

  const keySchedules = [
    {
      title: "VIEW TRENDS",
      subcategories: [
        {
          items: [
            { name: "Payment to Auditors", key: "payment_to_auditors" },
            { name: "Insurance Expenses", key: "insurance_expenses" },
            { name: "Power and Fuel", key: "power_and_fuel" },
          ],
        },
      ],
    },
  ];

  const ratios = [
    {
      title: "Ratios - AOC-4",
      subcategories: [
        {
          subtitle: "Ratios - AOC-4",
          items: [
            { name: "Revenue Growth (%)", key: "revenue_growth" },
            { name: "Gross Profit Margin (%)", key: "gross_profit_margin" },
            { name: "EBITDA Margin (%)", key: "EBIDTA_margin" },
            { name: "Net Margin (%)", key: "net_margin" },
            {
              name: "Return on Partners'Fund (%)",
              key: "return_on_partners_fund",
            },
            {
              name: "Return on Capital Employed (%)",
              key: "return_on_capital_employed",
            },
            { name: "Debt Ratio", key: "debt_ratio" },
            { name: "Debt / Partner's Fund", key: "debt_fund" },
            {
              name: "Interest Coverage Ratio",
              key: "interest_coverage_ration",
            },

            { name: "Inventory / Sales (Days)", key: "inventory_days" },
            { name: "Debtors / Sales (Days)", key: "debtors_days" },
            { name: "Payables / Sales (Days)", key: "payables_days" },
            {
              name: "Cash Conversion Cycle (Days)",
              key: "cash_conversion_cycle_days",
            },
            { name: "Sales / Net Fixed Assets", key: "sales_netfixed_assets" },
          ],
        },
      ],
    },
  ];

  const convertValue = (value) => {
    switch (currency) {
      case "Lakh":
        return value * 100;
      case "Million":
        return value * 10;
      case "INR":
        return value * 10000000;
      case "Crore":
      default:
        return value;
    }
  };

  return (
    <div className={styles.financial_Data_table_subcontainer}>
      <div className={styles.financialdata_currency}>
        <div className={styles.Compilance_header_text}>
          STATEMENT OF ACCOUNT
        </div>
        {hasData && (
          <>
            <div className={styles.yearSelectContainer}>
              <select
                className={styles.financialYearselect}
                value={selectedDateRange}
                onChange={(e) => setSelectedDateRange(e.target.value)}
              >
                <option value="" disabled>
                  Select Year Range
                </option>
                {financialYears.length > 0 &&
                  financialYears.map((year, index) => (
                    <option
                      key={index}
                      value={`${year} - ${parseInt(year) + 1}`}
                    >
                      {`${year} - ${parseInt(year) + 1}`}
                    </option>
                  ))}
              </select>
            </div>
            <div className={styles.financialdata_currency_select}>
              <div>
                <FaRupeeSign />
              </div>
              <div>
                <select
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  className="unit-width"
                >
                  <option value="Crore">Crore</option>
                  <option value="Lakh">Lakh</option>
                  <option value="INR">INR</option>
                  <option value="" disabled>
                    --------
                  </option>
                  <option value="Million">Million</option>
                </select>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Standalonetwo Section */}
      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandaltwoOpen}
        aria-controls="financial-data-table"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandaltwo}>
          {isStandaltwoOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>
          Statement of Assets and Liabilities( ₹ {currency} )
        </h3>
      </div>

      {isStandaltwoOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.reference_document?.MaiinFileName ? (
                    <a
                      href={item?.reference_document?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.reference_document?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.reference_document?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div className={styles.scrollWrapper} ref={tableRef2}>
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Statement of Assets and Liabilities ( ₹ {currency} )
                  </th>
                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {[...AssetsandLiabilities].map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td
                            className={styles.financial_scroll_table}
                            id={styles.financial_title}
                          >
                            {section.title}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            {subcategory.subtitle && (
                              <tr>
                                <td
                                  className={styles.financial_scroll_table}
                                  id={styles.financial_subtitle}
                                >
                                  {subcategory.subtitle}
                                </td>
                                <td></td>
                              </tr>
                            )}
                            {subcategory.items.map((category, idx) => (
                              <tr
                                key={idx}
                                className={styles.financial_scroll_table}
                              >
                                <td
                                  className={`${styles.financial_scroll_table}`}
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#000000",
                                  }}
                                >
                                  {category.name}
                                </td>
                                {/* {filteredData.map((data, index) => {
                                  const value = data?.[category.key];
                                  const convertedValue =
                                    value !== undefined && value !== null
                                      ? convertValue(value)
                                      : "-";
                                  return (
                                    <td
                                      key={index}
                                      style={{
                                        color: "#030712",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {convertedValue}
                                    </td>
                                  );
                                })} */}
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financial_year === Number(year)
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? convertValue(value)
                                        : " - ";

                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2}>No Statement of Assets and Liabilities  available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Standalonethree Section */}
      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandalthreeOpen}
        aria-controls="financial-data-table"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandalthree}>
          {isStandalthreeOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>
          Statement of Income and Expenditure ( ₹ {currency} )
        </h3>
      </div>

      {isStandalthreeOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.reference_document?.MaiinFileName ? (
                    <a
                      href={item?.reference_document?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.reference_document?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.reference_document?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div className={styles.scrollWrapper} ref={tableRef3}>
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Statement of Income and Expenditure ( ₹ {currency} )
                  </th>
                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {[...IncomeandExpenditure].map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td
                            className={styles.financial_scroll_table}
                            id={styles.financial_title}
                          >
                            {section.title}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            {/* Removed subtitle row here */}
                            {subcategory.items.map((category, idx) => (
                              <tr
                                key={idx}
                                className={styles.financial_scroll_table}
                              >
                                <td
                                  className={styles.financial_scroll_table}
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#000000",
                                  }}
                                >
                                  {category.name}
                                </td>
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financial_year === Number(year)
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? convertValue(value)
                                        : " - ";
                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2} style={{textAlign:"center"}}>No Statement of Income and Expenditure available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Standalonefour Section */}
      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandalfourOpen}
        aria-controls="financial-data-table"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandalfour}>
          {isStandalfourOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>
          Statement of Income and Expenditure - Key Schedule ( ₹ {currency} )
        </h3>
      </div>

      {isStandalfourOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.reference_document?.MaiinFileName ? (
                    <a
                      href={item?.reference_document?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.reference_document?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.reference_document?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div className={styles.scrollWrapper} ref={tableRef4}>
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Statement of Income and Expenditure - Key Schedule ( ₹{" "}
                    {currency} )
                  </th>
                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {[...keySchedules].map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td
                            className={styles.financial_scroll_table}
                            id={styles.financial_title}
                          >
                            {section.title}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            {/* Subtitle row removed */}
                            {subcategory.items.map((category, idx) => (
                              <tr
                                key={idx}
                                className={styles.financial_scroll_table}
                              >
                                <td
                                  className={styles.financial_scroll_table}
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#000000",
                                  }}
                                >
                                  {category.name}
                                </td>
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financial_year === Number(year)
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? convertValue(value)
                                        : " - ";

                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2} style={{textAlign:"center"}}>No Statement of Income and Expenditure available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Standalonefive Section */}
      <div
        className={styles.highlet_header_content1}
        role="button"
        aria-expanded={isStandalfiveOpen}
        aria-controls="financial-data-table"
        tabIndex={0}
      >
        <p className={styles.minuse_icon} onClick={toggleStandalfive}>
          {isStandalfiveOpen ? (
            <FaMinusSquare size={22} />
          ) : (
            <FaPlusSquare size={22} />
          )}
        </p>
        <h3 className={styles.highlet_text}>Ratios ( ₹ {currency} )</h3>
      </div>

      {isStandalfiveOpen && isSubScribe && (
        <div>
          <div
            style={{ backgroundColor: "#F3F5F7" }}
            className={styles.referencedoc_main}
          >
            <div>
              <b>Reference Documents</b>
            </div>
            <div className={styles.referencedoc_container}>
              {filteredData.map((item, index) => (
                <span key={index}>
                  {item?.reference_document?.MaiinFileName ? (
                    <a
                      href={item?.reference_document?.fileurl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.referencedoc_mainfilename}
                    >
                      {item?.reference_document?.MaiinFileName}
                    </a>
                  ) : (
                    <p>No documents available for selected year</p>
                  )}
                  <ul style={{ padding: 0 }}>
                    {item?.reference_document?.Attachments?.map((doc, idx) => (
                      <li key={idx} className={styles.referencedoc_Attachments}>
                        <IoDocumentTextOutline
                          size={16}
                          style={{
                            marginRight: "8px",
                            color: "#2961EF",
                          }}
                        />
                        <a
                          href={doc.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#2961EF",
                          }}
                        >
                          {doc.Name}
                        </a>
                        <button
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = doc.fileurl;
                            link.download = doc.Name;
                            link.click();
                          }}
                          title="Download"
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            color: "#2961EF",
                            marginLeft: "5px",
                            textDecoration: "underline",
                          }}
                        >
                          <FiDownload />
                        </button>
                      </li>
                    ))}
                  </ul>
                </span>
              ))}
            </div>
          </div>
          <div className={styles.scrollWrapper} ref={tableRef5}>
            <table className={styles.financialtable}>
              <thead className={styles.financialyear_header}>
                <tr className={styles.financial_scroll_table}>
                  <th className={styles.financial_name}>
                    Ratios ( ₹ {currency} )
                  </th>
                  {filteredData.length > 0 &&
                    selectedDateRange &&
                    selectedDateRange.split(" - ").length === 2 && (
                      <>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[0]}
                        </th>
                        <th className={styles.financial_name}>
                          {selectedDateRange.split(" - ")[1]}
                        </th>
                      </>
                    )}
                </tr>
              </thead>
              <tbody>
                {hasData ? (
                  <>
                    {[...ratios].map((section, sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        <tr>
                          <td
                            className={styles.financial_scroll_table}
                            id={styles.financial_title}
                          >
                            {section.title}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        {section.subcategories.map((subcategory, subIndex) => (
                          <React.Fragment key={subIndex}>
                            <tr>
                              <td
                                className={styles.financial_scroll_table}
                                id={styles.financial_subtitle}
                              >
                                {subcategory.subtitle}
                              </td>
                              <td></td>
                            </tr>
                            {subcategory.items.map((category, idx) => (
                              <tr
                                key={idx}
                                className={styles.financial_scroll_table}
                              >
                                <td
                                  className={`${styles.financial_scroll_table}`}
                                  style={{
                                    fontWeight: category.bold
                                      ? "bold"
                                      : "normal",
                                    color: "#000000",
                                  }}
                                >
                                  {category.name}
                                </td>
                                {/* {filteredData.map((data, index) => {
                                  const value = data?.[category.key];
                                  const convertedValue =
                                    value !== undefined && value !== null
                                      ? convertValue(value)
                                      : "0";
                                  return (
                                    <td
                                      key={index}
                                      style={{
                                        color: "#030712",
                                        fontWeight: "800",
                                      }}
                                    >
                                      {convertedValue}
                                    </td>
                                  );
                                })} */}
                                {selectedDateRange
                                  .split(" - ")
                                  .map((year, index) => {
                                    const data = filteredData.find(
                                      (d) => d.financial_year === Number(year)
                                    );
                                    const value = data?.[category.key];
                                    const displayValue =
                                      value !== undefined && value !== null
                                        ? convertValue(value)
                                        : " - ";

                                    return (
                                      <td
                                        key={index}
                                        style={{
                                          color: "#030712",
                                          fontWeight: "800",
                                        }}
                                      >
                                        {displayValue}
                                      </td>
                                    );
                                  })}
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={filteredData.length + 2}>No Ratios available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default LLPStatementOfAccount;
